import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomefirstScoresComponent } from './homefirst-scores.component';

const routes: Routes = [
  {
    path: '',
    component: HomefirstScoresComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomefirstScoresRoutingModule {}
